module.exports = new __parcel__URL__("corn.f527dc60.svg").toString();